import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Scissors, Palette, X } from 'lucide-react';
const classicServices = [{
  name: 'Corte',
  price: '390'
}, {
  name: 'Barba',
  price: '120'
}, {
  name: 'Corte y barba',
  price: '490'
}];
const colorServices = [{
  name: 'Mechitas',
  price: '1400'
}, {
  name: 'Color completo',
  price: '2000'
}, {
  name: 'Mechitas y corte',
  price: '1690'
}, {
  name: 'Color completo + corte',
  price: '2290'
}];
interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PricingModal({
  isOpen,
  onClose
}: PricingModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-201" data-mp="38oxchgpoy8ky">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100]" data-id="element-202" data-mp="38r1pco5kihxd" />

          {/* Modal Content */}
          <div className="fixed inset-0 z-[101] flex items-center justify-center p-4 sm:p-6 overflow-y-auto pointer-events-none" data-id="element-203" data-mp="3rmrs4dlbricb">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-4xl pointer-events-auto my-auto" data-id="element-204" data-mp="3mmvmk9wzbiun">
              <div className="bg-[#0a0a0a] border border-white/10 rounded-3xl p-6 md:p-10 relative overflow-hidden shadow-2xl" data-id="element-205" data-mp="333cwgb4gl8ze">
                {/* Close Button */}
                <button onClick={onClose} className="absolute top-6 right-6 p-2 rounded-full bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white transition-colors z-20" data-id="element-206" data-mp="3c27z5d8ao0xy">
                  <X size={24} data-id="element-207" data-mp="3lrrmav31igym" />
                </button>

                {/* Background Glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-96 bg-neon-violet/10 rounded-full blur-[120px] pointer-events-none" data-id="element-208" data-mp="3qqba711722tm" />

                <div className="relative z-10" data-id="element-209" data-mp="3lvc0dtrjni6">
                  <div className="text-center mb-12" data-id="element-210" data-mp="3kk9ehc20lsn">
                    <h2 className="font-display text-4xl md:text-6xl mb-2" data-id="element-211" data-mp="20g9mskc2hog1">
                      Nuestros{' '}
                      <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-green to-neon-violet" data-id="element-212" data-mp="25etaap6b78ai">
                        Precios
                      </span>
                    </h2>
                    <p className="text-gray-400" data-id="element-213" data-mp="1t2h6ymp45y4q">
                      Inversión en tu imagen. Servicios de alta calidad.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-214" data-mp="1j6nm8g18qybv">
                    {/* Classic Services Card */}
                    <div className="bg-white/[0.03] border border-white/10 backdrop-blur-lg rounded-2xl p-6 md:p-8 relative overflow-hidden group hover:border-neon-green/30 transition-colors duration-500" data-id="element-215" data-mp="2gt4g1barmtsv">
                      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-neon-green to-transparent opacity-50" data-id="element-216" data-mp="26tnb4w3c8jxy" />

                      <div className="flex items-center gap-4 mb-8" data-id="element-217" data-mp="vgt7tu19x1pi">
                        <div className="w-10 h-10 rounded-xl bg-neon-green/10 flex items-center justify-center text-neon-green" data-id="element-218" data-mp="vdyok5tzxmxo">
                          <Scissors size={20} data-id="element-219" data-mp="2faw0for6a0ar" />
                        </div>
                        <h3 className="text-xl font-bold text-white" data-id="element-220" data-mp="2k24a8lweznog">
                          Barbería Clásica
                        </h3>
                      </div>

                      <div className="space-y-5" data-id="element-221" data-mp="25f1d4gc07h1n">
                        {classicServices.map((service, index) => <div key={index} className="flex items-center justify-between group/item" data-id="element-222" data-mp="2a9yjtglt9ebd" data-mpi={index}>
                            <span className="text-gray-300 font-medium group-hover/item:text-white transition-colors" data-id="element-223" data-mp="32yw2vlxujf56">
                              {service.name}
                            </span>
                            <div className="flex-1 border-b border-dashed border-white/10 mx-4 relative top-1 group-hover/item:border-neon-green/30 transition-colors" data-id="element-224" data-mp="2t4vpyxwbp5lw" />
                            <span className="text-lg font-bold text-white" data-id="element-225" data-mp="1hof6mthne4tr">
                              ${service.price}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    {/* Color Services Card */}
                    <div className="bg-white/[0.03] border border-white/10 backdrop-blur-lg rounded-2xl p-6 md:p-8 relative overflow-hidden group hover:border-neon-violet/30 transition-colors duration-500" data-id="element-226" data-mp="1k1sj9sd7f38b">
                      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-neon-violet to-transparent opacity-50" data-id="element-227" data-mp="rdwlslft97ah" />

                      <div className="flex items-center gap-4 mb-8" data-id="element-228" data-mp="113y7j6koydm8">
                        <div className="w-10 h-10 rounded-xl bg-neon-violet/10 flex items-center justify-center text-neon-violet" data-id="element-229" data-mp="wcq18jenr8da">
                          <Palette size={20} data-id="element-230" data-mp="8mc7mogfd1gl" />
                        </div>
                        <h3 className="text-xl font-bold text-white" data-id="element-231" data-mp="3oao62f3704l">
                          Colorimetría
                        </h3>
                      </div>

                      <div className="space-y-5" data-id="element-232" data-mp="tby0fjc5b20y">
                        {colorServices.map((service, index) => <div key={index} className="flex items-center justify-between group/item" data-id="element-233" data-mp="xbf5wcrknz64" data-mpi={index}>
                            <span className="text-gray-300 font-medium group-hover/item:text-white transition-colors" data-id="element-234" data-mp="175p8soe54fv3">
                              {service.name}
                            </span>
                            <div className="flex-1 border-b border-dashed border-white/10 mx-4 relative top-1 group-hover/item:border-neon-violet/30 transition-colors" data-id="element-235" data-mp="eh05qjtiy0gp" />
                            <span className="text-lg font-bold text-white" data-id="element-236" data-mp="odwhcyepz2ph">
                              ${service.price}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div className="mt-10 text-center" data-id="element-237" data-mp="3k99gbjuhpeaa">
                    <a href="#reservar" onClick={onClose} className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-white font-semibold transition-all duration-300 shadow-[0_0_20px_rgba(168,85,247,0.3)] hover:scale-105" data-id="element-238" data-mp="3fb7x8yx2deyt">
                      Agendar un turno ahora
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}